<!-- eslint-disable vue/no-unused-vars -->
<template>
	<b-card no-body  v-loading="is_loading_table">

		<DrawerFilterPendingAcceptance ref="drawer_filter_pending_acceptance" @filter="setFilter($event)" />
		<sms-drawer ref="drawer_sms" />

		<!--<b-card-header class="border-0">
			<b-row></b-row>
		</b-card-header> -->
		<b-card-body>
			<b-row class="d-flex d-flex-wrap align-items-start mb-3 mx-2">
					<b-col cols="12" class="px-0 mb-1">
						<p class="font-weight-bold text-muted">Pending Acceptance Status</p>
					</b-col>
					<b-col cols="auto" class="px-1">
							<b-button
									block
									:variant="this.filters.loan_ec_status == 'all' || _gHlp.isEmpty(this.filters.loan_ec_status) ? 'primary' : 'outline-primary'"
									class="mb-2 mr-2 shadow-none"
									@click="setTabFilter({loan_ec_status:''})"
							>
									<span class="font-weight-600">All</span><br>
									{{ _gHlp.getValue(tableSummary,'total_all',0) }}
							</b-button>
					</b-col>
					<b-col cols="auto" class="px-1">
							<b-button
									block
									:variant="this.filters.loan_ec_status == 'Pending Submission' ? 'primary' : 'outline-primary'"
									class="mb-2 mr-2 shadow-none"
									@click="setTabFilter({loan_ec_status:'Pending Submission'})"
							>
									<span class="font-weight-600">Pending Submission</span><br>
									{{ _gHlp.getValue(tableSummary,'sts_pending_submission',0) }}
							</b-button>
					</b-col>
					<b-col cols="auto" class="px-1">
							<b-button
									block
									:variant="this.filters.loan_ec_status == 'Pending Approval' ? 'primary' : 'outline-primary'"
									class="mb-2 mr-2 shadow-none"
									@click="setTabFilter({loan_ec_status:'Pending Approval'})"
							>
									<span class="font-weight-600">Pending Approval</span><br>
									{{ _gHlp.getValue(tableSummary,'sts_pending_approval',0) }}
							</b-button>
					</b-col>
					<b-col cols="auto" class="px-1">
							<b-button
									block
									:variant="this.filters.loan_ec_status == 'Rejected' ? 'primary' : 'outline-primary'"
									class="mb-2 mr-2 shadow-none"
									@click="setTabFilter({loan_ec_status:'Rejected'})"
							>
									<span class="font-weight-600">Rejected</span><br>
									{{ _gHlp.getValue(tableSummary,'sts_rejected',0) }}
							</b-button>
					</b-col>
			</b-row>
			<b-row class="d-flex d-flex-wrap align-items-start mb-3 mx-2">
				<!-- LEFT SECTION -->
				<b-col cols="auto" class="px-1 py-1">
					<el-input placeholder="Search by text" v-model="filters.search_txt" @change="getListing(true)"> <i slot="prefix"
							class="el-input__icon el-icon-search"></i>
					</el-input>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-select v-model="filters.date_type" placeholder="Select Date Type" @change="setDateFilters">
						<el-option v-for="item in dateFilterOpt" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</b-col>
				<b-col cols="auto" class="px-1 py-1" :class="['this_month','last_month'].includes(filters.date_type) || _gHlp.isEmpty(filters.date_type) ? 'd-none': ''">
					<el-date-picker v-model="filters.date_start" value-format="yyyy-MM-dd" type="date" placeholder="Pick start date" @change="setFilter({})"></el-date-picker>
				</b-col>
				<b-col cols="auto" class="px-1 py-1" :class="['this_month','last_month'].includes(filters.date_type) || _gHlp.isEmpty(filters.date_type) ? 'd-none': ''">
					<el-date-picker v-model="filters.date_end" value-format="yyyy-MM-dd" type="date" placeholder="Pick end date" @change="setFilter({})"></el-date-picker>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-button type="gray" plain @click="$refs.drawer_filter_pending_acceptance.show()" icon="el-icon-s-operation">
						Filters
					</el-button>
				</b-col>
				<b-col cols="auto" class="px-1 py-1">
					<el-button type="danger" plain @click="resetFilter()" icon="el-icon-circle-close">
						Clear 
					</el-button>
				</b-col>
			</b-row>

			<!-- CARDS -->
			<b-row>
				<b-col cols="12" md="8" class="d-flex align-items-center">
					<div class="border rounded p-3 mx-2">
						<p>Total Loan Amount</p>
						<h3 class="mb-0 text-primary">RM {{ _gHlp.getValue(tableSummary,'total_loan_amount') || 0 | moneyFormatter }}</h3>
					</div>
				</b-col>
			</b-row>
		</b-card-body>

		<div class="table-listings">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="selectionChange"
				class="mt-4" >
				<el-table-column type="selection" width="45" class-name="individual-table-name"></el-table-column>
				<el-table-column width="70" class-name="icons-chat" :fixed="isFixed">
					<template slot-scope="scope">
						<MessagingBoxButton :type="'invinity_customer'" :profile="scope.row" />
					</template>
				</el-table-column>
				<el-table-column prop="customer" label="Customer/ SAS ID / PSAL ID" min-width="260" label-class-name="py-0" fixed sortable>
					<template slot="header" slot-scope="scope">
						<span class="text-break">Customer Name</span>
						<small class="d-block">CHANNEL / ID </small>
					</template>
					<template slot-scope="scope">
						<div>
							<div class="d-flex justify-content-between align-items-center w-100">
								<el-tooltip effect="dark" placement="right">
									<div slot="content" class="d-flex align-items-center">
										{{ scope.row.name }}
										<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer ml-2"
											@click.prevent="_gHlp.copyToClipboard(scope.row.name)" width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
										</svg>
									</div>
									<router-link event @click.native.prevent="$event => clickDetail(scope.row)"
										:to="'/customer/pending-customer-detail/'+scope.row.customer_id+'?lec_id='+scope.row.id">
										<p class="font-weight-500 text-primary text-elipsis">{{ scope.row.name }}</p>
									</router-link>
								</el-tooltip>
								<!-- <el-tooltip effect="dark" placement="bottom">
									<div slot="content">
										Low (80% DSR & limit below 30k)
									</div>
									<div style="height: 18px; width: 18px;"
										:style="{ 'background-color': _gConst.getRiskColor(scope.row.risk) }"
										class="rounded text-center d-flex justify-content-center align-items-center">
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 288 512"
											class="text-center">
											<path fill="#fff"
												d="M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z" />
										</svg>
									</div>
								</el-tooltip> -->
							</div>
							<p class="mb-0 bottom-line d-flex align-items-center">
								<b-badge :pill="true" class="badge-tertiary">{{ scope.row.channel || '-' }}</b-badge>
								<span class="px-2">{{ scope.row.customer_id }}</span>
							</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="Contact" width="150">
					<template slot-scope="scope">
						<!-- Phone Icon -->
						<svg v-b-tooltip.hover="scope.row.contact_no ? scope.row.contact_no : 'N/A'" @click="sendWhatsapp(scope.row)"
							xmlns="http://www.w3.org/2000/svg" class="rounded-circle p-1 bg-primary" width="28" height="28"
							viewBox="0 0 24 24">
							<path fill="#fff"
								d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 0 0-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02c-.37-1.11-.56-2.3-.56-3.53c0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99C3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
						</svg>
						<!-- Mail Icon -->
						<svg v-b-tooltip.hover="scope.row.email ? scope.row.email : 'N/A'" xmlns="http://www.w3.org/2000/svg"
							class="rounded-circle p-1 bg-primary mx-2" width="28" height="28" viewBox="0 0 24 24"
							style="cursor: pointer;" @click="$refs.sms_drawer.viewSmsDrawer()">
							<path fill="#fff" d="M22 4H2v16h20V4zm-2 4l-8 5l-8-5V6l8 5l8-5v2z" />
						</svg>
					</template>
				</el-table-column>
				<el-table-column label="Created/Updated" min-width="200" prop="created" sortable>
					<template slot-scope="scope">
						<p class="top-line">
							{{ scope.row.created_at | dateFormatString }}
						</p>
						<p class="bottom-line">
							{{ scope.row.updated_at | dateFormatString }}
						</p>
					</template>
				</el-table-column>
				<el-table-column label="Net Income" min-width="170" prop="net_income">
					<template slot-scope="scope">
						<div>
							<p>RM {{ scope.row.net_income || '-' | moneyFormatter }}</p>
						</div>
					</template>
				</el-table-column>
				
				<el-table-column label="Total Commitment/DSR" min-width="210" prop="total_commitment" sortable>
					<template slot-scope="scope">
						<p class="mb-0 top-line">RM {{ scope.row.ccris_commitment || '-' | moneyFormatter }}</p>
						<p class="mb-0 bottom-line">{{ scope.row.dsr ? scope.row.dsr + '%' : '0' }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Total Apply Loan Amount" min-width="190" prop="total_apply_loan_amount" sortable>
					<template slot-scope="scope">
						<p class="">RM {{ scope.row.ec_loan_amount | moneyFormatter }}</p>
					</template>
				</el-table-column>
				<el-table-column label="SSA" min-width="110">
					<template slot="header" slot-scope="scope">
						<span class="text-break">SSA</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="_gHlp.formatInitials(scope.row.ssa_name)"
							v-b-tooltip.hover="scope.row.ssa_name" v-if="!_gHlp.isEmpty(scope.row.ssa_name) && (scope.row.ssa_name != '-')"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="SSA Manager" min-width="110">
					<template slot="header" slot-scope="scope">
						<span class="text-break">SSA Manager</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="_gHlp.formatInitials(scope.row.ssa_manager_name)"
							v-b-tooltip.hover="scope.row.ssa_manager_name" v-if="!_gHlp.isEmpty(scope.row.ssa_manager_name) && (scope.row.ssa_manager_name != '-')"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="Credit Officer" min-width="110" prop="credit_officer" sortable show-overflow-tooltip>
					<template slot="header" slot-scope="scope">
						<span class="text-break">Credit Officer</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="_gHlp.formatInitials(scope.row.loan_officer_name)"
							v-b-tooltip.hover="scope.row.loan_officer_name" v-if="!_gHlp.isEmpty(scope.row.loan_officer_name) && (scope.row.loan_officer_name != '-')"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column>
				<el-table-column label="Credit Manager" min-width="110">
					<template slot="header" slot-scope="scope">
						<span class="text-break">Credit Manager</span>
					</template>
					<template slot-scope="scope">
						<b-avatar size="32px" :text="_gHlp.formatInitials(scope.row.credit_manager_name)"
							v-b-tooltip.hover="scope.row.credit_manager_name" v-if="!_gHlp.isEmpty(scope.row.credit_manager_name) && (scope.row.credit_manager_name != '-')"></b-avatar>
						<span v-else>-</span>
					</template>
				</el-table-column>
				
				<el-table-column fixed="right" width="25" align="center" class-name="px-0">
					<template slot-scope="scope">
						<el-dropdown trigger="click" style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>
									<!-- Eye Icon -->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
										<path fill="#13663E"
											d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
									</svg>
									View Change Log
								</el-dropdown-item>
								<el-dropdown-item>
									<span class="text-danger">
										<!-- Trash-Can Icon -->
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
											<path fill="#DF3030"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
										</svg>
										Delete
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
			<div class="">
				<p class="card-category">
					Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>
			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="pagination.total" @change="paginationChanged($event)">
			</base-pagination>
		</div>
	</b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button, DatePicker } from 'element-ui'
import 'sweetalert2/dist/sweetalert2.css'
import DrawerFilterPendingAcceptance from '@/views/PendingAcceptance/Drawers/DrawerFilterPendingAcceptance'
import SmsDrawer from '@/views/Sms/SmsDrawer'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { BasePagination } from '@/components'
import { debounce } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useMessagingStore } from '@/stores/messagingStore'
import _ from 'lodash';
import moment from 'moment'

export default {
	mixins: [clientPaginationMixin],
	components: {
		BasePagination,
		MessagingBoxButton,
		DrawerFilterPendingAcceptance,
		SmsDrawer,
		[DatePicker.name]: DatePicker,
		[Select.name]: Select,
		[Option.name]: Option,
		[Tooltip.name]: Tooltip,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Button.name]: Button,
	},
	data() {
		return {
			propsToSearch: ['customer_name', 'agent_name'],
			tableData: [],
			tableSummary: {},
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			is_loading_table: false,
			isFixed: true,
			filters:{
				search_txt:'',
				status:'',
				profile_type:'normal_customer',
				loan_ec_status:'',
				date_type: '',
				date_start: '',
				date_end: '',
			},
			dateFilterOpt: [{
				value: 'this_month',
				label: 'This Month'
			},
			{
				value: 'last_month',
				label: 'Last Month'
			},
			{
				value: 'created_at',
				label: 'Created Date'
			}, 
			{
				value: 'updated_at',
				label: 'Updated Date'
			}],
		};
	},
	created() {
		this.getListing(true,true);
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			// this.searchFinancialProposalList();
		}, 500);
		// this.setFixed();
		// window.addEventListener('resize', this.setFixed);
	},
	beforeDestroy() {
		// window.removeEventListener('resize', this.setFixed);
	},
	computed: {
	},
	methods: {
		...mapActions(useAccessControlStore, ['getUser']),
		...mapActions(useCustomerStore, ['getLoanEcList','getCustomer','getLoanEC']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries']),
		getFilters(){
			let filtered = {};
			let obj = this.filters;
			Object.keys(obj).forEach(key => {
					if (!_gHlp.isEmpty(obj[key])) {
							filtered[key] = obj[key];
					}
			});
			return filtered;
		},
		setFilter(obj){
			this.filters = { ...this.filters, ...obj }
			this.getListing(true,true)
		},
		setTabFilter(obj){
			this.filters = { ...this.filters, ...obj }
			this.getListing(true)
		},
		resetFilter() {
			Object.keys(this.filters).forEach(key => {
				this.filters[key] = ''
			});
			this.setFilter({})
		},
		setDateFilters(value){
			if(value == 'this_month'){
				this.filters.date_start = moment().startOf('month').format('YYYY-MM-DD')
				this.filters.date_end = moment().format('YYYY-MM-DD')
				this.setFilter({});
			}else if(value == 'last_month'){
				this.filters.date_start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
				this.filters.date_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
				this.setFilter({});
			}
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
			this.getListing()
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		async getListing(resetPage=false, resetSummary=false) {
			this.is_loading_table = true;

			const params = {
				search: this.getFilters(),
				paginate: this.pagination.perPage,
				page: (resetPage) ? 1 : this.pagination.currentPage
			};
			const dataList = await this.getLoanEcList(params, true);

			//INJECT CUSTOMER DETAIL
			let tableData = [];
			for (let i = 0; i < dataList.data.length; i++) {
				let el = dataList.data[i];
				// el['loan_officer_name'] = await this.getUser(el.loan_officer_id, 'name', null);
				// el['sse_name'] = await this.getUser(el.sse_id, 'name', null);
				tableData.push(el);
			}
			this.tableData = tableData
			if (resetSummary) {
				this.tableSummary = dataList.summary;
			}
			this.pagination = dataList.pagination
			this.getProfileListMessagesSummaries('invinity_customer', this.tableData);
			// this.setStatusSummary()
				this.is_loading_table = false;
		},
		// setFixed() {
		// 	this.isFixed = window.innerWidth > 768;
		// },
		// filterByProposalStatus(event) {
		// },
		loanEligibilityMap(status) {
			switch (status) {
				case 'PA':
					return 'Pending Approv.'
					break;
				case 'A':
					return 'Approved'
					break;
				default:
					return status;
					break;
			}
		},
		async clickDetail(item) {
			this.is_loading_table = true;
			
			this.getCustomer(item.customer_id).then(resp => {
				this.getLoanEC(item.id, item.customer_id).then(resp => {
					this.$router.push('/customer/pending-customer-detail/'+resp.customer_id+'?lec_id='+resp.id);
					this.is_loading_table = false;
				}).catch(err=>{
					this.is_loading_table = false;
				});
			})
		},

		sendWhatsapp(item) {
			let phoneNo = item.phone_no;
			const prefix = phoneNo.substring(0, 1);
			const countryPrefix = phoneNo.substring(1, 2);
			if (prefix === '0') {
				if (countryPrefix === '8') {
					phoneNo = '62' + phoneNo.substring(1);
				} else {
					phoneNo = '6' + phoneNo;
				}
			}
			window.open(`https://api.whatsapp.com/send?phone=${phoneNo}`, '_blank');
		}
	}
}

</script>
